import React, { useMemo } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { TEXT_CONSTANT, IMAGE_CONSTANT } from '../../../constants/app';
import LazyImage from '../../../ui-core/Image';
import Button from '../../../ui-core/Button/Button';
import { formatCurrency, getDisplayType } from '../../../utils/helpers';
import useWindowWidth from '../../../hooks/useWindowWidth';

import './style.css';

const JenCalender = props => {
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const featuresListOne = [
    '30-Day Calender',
    'Automatically Tracks Progress',
    'Daily Accountability Check-Ins',
  ];

  const currentPrice = useMemo(() => {
    return props.courseDetail?.attributes?.amount
      ? +props.courseDetail?.attributes?.amount / 100
      : 0;
  }, [props.courseDetail?.attributes?.amount]);

  // const originalPrice = useMemo(() => {
  //   return currentPrice + (props.courseDetail?.attributes?.discount || 0);
  // }, [currentPrice, props.courseDetail?.attributes?.discount]);

  const perDayPrice = useMemo(() => {
    return Math.ceil(currentPrice / 30);
  }, [currentPrice]);

  const handleClick = () => {
    if (props.onClick) {
      props.onClick(
        TEXT_CONSTANT.I_AM_IN,
        'isSignup',
        TEXT_CONSTANT.GRATEFUL_FOR_MY_BODY,
      );
    }
  };
  return (
    <div className="jen-calender">
      <Row className="jen-calender-text">
        {/* <p>{`A $300 value at minimum and we are giving it to you for ${formatCurrency(
          currentPrice,
          props.courseDetail?.attributes?.currency,
          0,
        )}!`}</p> */}
        <h4>{`All of this for only ${formatCurrency(
          perDayPrice,
          props.courseDetail?.attributes?.currency,
          0,
        )}/day when you sign up!`}</h4>
      </Row>
      <Row className="jen-cal-row">
        <Col md={1}></Col>
        <Col md={5}>
          <ul>
            {featuresListOne.map(feature => (
              <li className="mb-2" key={feature}>
                <p>{feature}</p>
              </li>
            ))}
          </ul>
          <Button
            isDisabled={props.loading}
            isLoading={props.loading}
            class="sign-up-button-new text-uppercase ms-2"
            text={TEXT_CONSTANT.I_AM_IN}
            onClick={handleClick}
          />
        </Col>
        <Col md={6}>
          <LazyImage
            alt="jen calendar"
            className="img-fluid"
            errorSrc={
              isMobileScreen
                ? IMAGE_CONSTANT.JenCalenderMobile
                : IMAGE_CONSTANT.JenCalenderImage
            }
            placeholderSrc={
              isMobileScreen
                ? IMAGE_CONSTANT.JenCalenderMobileLow
                : IMAGE_CONSTANT.JenCalenderImageLow
            }
            src={
              isMobileScreen
                ? IMAGE_CONSTANT.JenCalenderMobileWebp
                : IMAGE_CONSTANT.JenCalenderImageWebp
            }
          />
        </Col>
      </Row>
    </div>
  );
};

JenCalender.propTypes = {
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  courseDetail: PropTypes.object,
};

export default JenCalender;
